import { useEffect, useState } from "react"

//Styles
import myStyles from "../../../../styles/referrals/ReferralEntityList.module.css"

//Formik
import { Form, Formik } from "formik"
import FormikTextInput from "../../../../helpers/formikInputs/FormikTextInput"
import FormikDropDown from "../../../../helpers/formikInputs/FormikDropDown"
import FormikCalendar from "../../../../helpers/formikInputs/FormikCalendar"
import FormikTreeSelect from "../../../../helpers/formikInputs/FormikTreeSelect"
import RefGoogleAutoComplete from "../Input/RefTextInputGooglePlaces"
import MapSearchRangeSlider from "../EntitySearch/MapSearchRangeSlider"

export default function ReferralEntitiesListFilter({
  activeFilters,
  setActiveFilters,
  cityOptions,
  zipOptions,
  organizationOptions,
  staffOptions,
  referralCategories,
  isLoading,
  showMapFilters,
}) {
  const defaultFilter = {
    searchPhrase: "",
    createdFrom: undefined,
    createdTo: undefined,
    SkipPagination: false,
    allLocations: true,
    distance: 30,
    pageSize: activeFilters.pageSize,
    page: activeFilters.page,
  }

  const sortDirections = [
    { value: "Descending", icon: "arrow_downward" },
    { value: "Ascending", icon: "arrow_upward" },
  ]

  const [currentFilters, setCurrentFilters] = useState(defaultFilter)
  const [availableStaffOptions, setAvailableStaffOptions] = useState([])
  const [sortDirection, setSortDirection] = useState(sortDirections[0])

  useEffect(() => {
    if (!!activeFilters) {
      setCurrentFilters(activeFilters)
    }
  }, [activeFilters])

  useEffect(() => {
    if (
      availableStaffOptions.length === 0 &&
      !currentFilters.creatorOrganization
    ) {
      setAvailableStaffOptions(staffOptions)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffOptions])

  return (
    <>
      <Formik
        initialValues={currentFilters}
        enableReinitialize
        onSubmit={(values) => {
          values.includeFilterListing = false
          values.PageNum = 1
          setActiveFilters(values)
        }}
      >
        {({
          handleSubmit,
          isSubmitting,
          dirty,
          values,
          setFieldValue,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit} autoComplete="off">
            <div className={myStyles.filterGridContainer}>
              <div className={myStyles.filterGridItemTitleSearch}>Search:</div>
              <div className={myStyles.filterGridItemSearchBox}>
                <FormikTextInput
                  label={""}
                  name={"searchPhrase"}
                  placeholderText={"Enter search phrase"}
                  disabled={isLoading}
                />
              </div>

              <div className={myStyles.filterGridItemTitleCreatedBy}>
                Creation organization:
              </div>
              <div className={myStyles.filterGridItemCreatedBy}>
                <FormikDropDown
                  label={""}
                  options={[
                    {
                      organization_id: "",
                      organization_name: "All organizations",
                    },
                    ...organizationOptions,
                  ]}
                  optionLabel={"organization_name"}
                  optionValue={"organization_id"}
                  name={"creatorOrganization"}
                  disabled={isLoading}
                  onChangeCallback={(value) => {
                    if (!value) {
                      setAvailableStaffOptions(staffOptions)
                    } else {
                      setAvailableStaffOptions(
                        staffOptions.filter(
                          (staff) => staff.organization_id === value
                        )
                      )
                    }
                  }}
                />
              </div>

              <div className={myStyles.filterGridItemTitleCreatedByUser}>
                Creation staff:
              </div>
              <div className={myStyles.filterGridItemCreatedByUser}>
                <FormikDropDown
                  label={""}
                  options={[
                    {
                      staff_id: "",
                      staff_full_name: "All staff",
                    },
                    ...availableStaffOptions,
                  ]}
                  optionLabel={"staff_full_name"}
                  optionValue={"staff_id"}
                  name={"creatorUser"}
                  disabled={isLoading}
                />
              </div>

              <div className={myStyles.filterGridItemTitleCreatedFromTitle}>
                Created on or after:
              </div>
              <div className={myStyles.filterGridItemCreatedFrom}>
                <FormikCalendar
                  name={"createdFrom"}
                  placeholderText={"Select a date"}
                  disabled={isLoading}
                />
              </div>
              <div className={myStyles.filterGridItemTitleCreatedToTitle}>
                Created before or on:
              </div>
              <div className={myStyles.filterGridItemCreatedTo}>
                <FormikCalendar
                  name={"createdTo"}
                  placeholderText={"Select a date"}
                  disabled={isLoading}
                />
              </div>

              <div className={myStyles.filterGridItemTitleType}>
                Referral type:
              </div>
              <div className={myStyles.filterGridItemType}>
                <FormikTreeSelect
                  name={`referralCategories`}
                  options={referralCategories}
                  disabled={isLoading}
                />
              </div>

              <div className={myStyles.filterGridItemTitleCity}>City:</div>
              <div className={myStyles.filterGridItemCity}>
                <FormikDropDown
                  label={""}
                  options={cityOptions}
                  optionLabel={"name"}
                  optionValue={"value"}
                  name={"city"}
                  disabled={isLoading}
                />
              </div>

              <div className={myStyles.filterGridItemTitleZip}>Zip:</div>
              <div className={myStyles.filterGridItemZip}>
                <FormikDropDown
                  label={""}
                  options={zipOptions}
                  optionLabel={"name"}
                  optionValue={"value"}
                  name={"zipCode"}
                  disabled={isLoading}
                />
              </div>
              {showMapFilters ? (
                <>
                  <div className={myStyles.filterGridItemTitleLocation}>
                    Map location
                  </div>
                  <div className={myStyles.filterGridItemLocation}>
                    <RefGoogleAutoComplete
                      onPlaceSelect={(e) => {
                        setFieldValue("address", e.formatted_address)
                        setFieldValue("latitude", e.geometry.location.lat())
                        setFieldValue("longitude", e.geometry.location.lng())
                      }}
                      disabled={isLoading}
                      defaultValue={values.address}
                    />
                  </div>
                  <div className={myStyles.filterGridItemTitleDistance}>
                    Distance filter
                  </div>
                  <div className={myStyles.filterGridItemDistance}>
                    <FormikDropDown
                      label={""}
                      options={[
                        { label: "In Range", value: false },
                        { label: "All", value: true },
                      ]}
                      optionLabel={"label"}
                      optionValue={"value"}
                      name={"allLocations"}
                      disabled={isLoading}
                    />
                  </div>
                  <div className={myStyles.filterGridItemTitleRange}>Range</div>
                  <div className={myStyles.filterGridItemRange}>
                    <MapSearchRangeSlider
                      rangeValue={values.distance}
                      onChange={(e) => {
                        setFieldValue("distance", e)
                      }}
                      isLoading={isLoading || values.allLocations}
                    />
                  </div>
                  <div className={myStyles.filterGridItemTitleSort}>
                    Sorting
                  </div>
                  <div className={myStyles.filterGridItemSort}>
                    <div className={myStyles.filterSortSelection}>
                      <FormikDropDown
                        label={""}
                        options={[
                          { label: "Name", value: "name" },
                          { label: "Status", value: "entityStatus" },
                          { label: "City", value: "city" },
                          { label: "Zip code", value: "zipcode" },
                          {
                            label: "Creator",
                            value: "creatingUserName",
                          },
                          {
                            label: "Creator Organization",
                            value: "creatingOrganization",
                          },
                          { label: "Creation date", value: "dateCreated" },
                        ]}
                        optionLabel={"label"}
                        optionValue={"value"}
                        name={"sortField"}
                        disabled={isLoading}
                      />
                    </div>

                    <button
                      className={`btn ${myStyles.filterSortDirection}`}
                      onClick={() => {
                        const newDirection =
                          sortDirections[!values.sortAscending ? 1 : 0]

                        setFieldValue("sortAscending", !values.sortAscending)
                        setSortDirection(newDirection)
                      }}
                      data-pr-position="bottom"
                      disabled={isLoading}
                    >
                      <span className="material-icons ">
                        {sortDirection.icon}
                      </span>
                    </button>
                  </div>
                </>
              ) : null}

              <div className={`${myStyles.filterGridItemButton}`}>
                <button
                  type="button"
                  className={`btn ${myStyles.filterButton} ${myStyles.filterButton2}`}
                  onClick={() => {
                    const clearFilter = {
                      ...defaultFilter,
                      sortField: activeFilters.sortField,
                      sortAscending: activeFilters.sortAscending,
                      latitude: activeFilters.latitude,
                      longitude: activeFilters.longitude,
                    }

                    if (!!setActiveFilters) {
                      setActiveFilters(clearFilter)
                    }
                    setCurrentFilters(clearFilter)
                    resetForm()
                  }}
                  disabled={isLoading}
                >
                  Clear
                </button>
                <button
                  type="submit"
                  className={`btn ${myStyles.filterButton}`}
                  disabled={!dirty || isLoading}
                >
                  Apply
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
